import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserNotesComponent } from '@zero/shared/ui-web-components';
import { MoneyTransactionOverviewComponent } from './money-transaction-overview/money-transaction-overview.component';
import { MoneyTransactionComponent } from './money-transaction/money-transaction.component';

@Component({
  templateUrl: './account-overview.component.html',
  imports: [UserNotesComponent, MoneyTransactionOverviewComponent, MoneyTransactionComponent, TranslocoPipe],
})
export class AccountOverviewComponent {}
